import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary'
import LocaleWrapper from '@/components/LocaleWrapper/LocaleWrapper'
import App from '@/App'

import Home from '@/pages/Home/Home' // Home é a única página que não é lazy-loaded, para evitar delay no carregamento inicial
// const Home = lazy(() => import('@/pages/Home/Home'))
const Portfolio = lazy(() => import('@/pages/Portfolio/Portfolio'))
const Libraries = lazy(() => import('@/pages/Libraries/Libraries'))
const About = lazy(() => import('@/pages/About/About'))
const NotFound = lazy(() => import('@/pages/NotFound/NotFound'))

/**
 * Factory — cria novos objetos de rota por chamada.
 * Necessário para evitar colisão de IDs do React Router quando o mesmo
 * conjunto de páginas é registrado em múltiplos locale prefixes.
 */
const makePageRoutes = (): RouteObject[] => [
  { index: true,              element: <Home /> },
  { path: 'projects',         element: <Portfolio /> },
  { path: 'libraries',        element: <Libraries /> },
  { path: 'about',            element: <About /> },
]

export const routes: RouteObject[] = [
  {
    // App é o layout raiz (header + footer + <Outlet />)
    path: '/',
    element: <ErrorBoundary><App /></ErrorBoundary>,
    children: [
      // pt-BR: sem prefixo de URL — pathless layout
      {
        element: <LocaleWrapper locale="pt-BR" />,
        children: makePageRoutes(),
      },
      // en-US: prefixo /en
      {
        path: 'en',
        element: <LocaleWrapper locale="en-US" />,
        children: [...makePageRoutes(), { path: '*', element: <NotFound /> }],
      },
      // es-ES: prefixo /es
      {
        path: 'es',
        element: <LocaleWrapper locale="es-ES" />,
        children: [...makePageRoutes(), { path: '*', element: <NotFound /> }],
      },
      // 404 global (rotas completamente inválidas como /fr, /invalid)
      { path: '*', element: <NotFound /> },
    ],
  },
]
